export default {"src":"/_next/static/image/src/images/Homepage/ollie-logo-inline.a6c00675a9ce7c7728b4197e10395362.svg","height":39,"width":79};